import { gql } from "@apollo/client";

// Fragments
export const MESSAGE_FRAGMENT = gql`
  fragment messageFragment on MessageType {
    role
    content
    timestamp
    recipeContext
  }
`;

export const CONVERSATION_CONTEXT_FRAGMENT = gql`
  fragment conversationContextFragment on ConversationContextType {
    conversationId
    currentRecipe
    messages {
      ...messageFragment
    }
    recipeContent
  }
  ${MESSAGE_FRAGMENT}
`;

export const RECIPE_STRUCTURE_FRAGMENT = gql`
  fragment recipeStructureFragment on RecipeStructureType {
    name
    template
    mandatory
    hasConstraints
  }
`;

export const RECIPE_SUMMARY_FRAGMENT = gql`
  fragment recipeSummaryFragment on RecipeSummaryType {
    title
    prescriptionDoses
    structureCount
    structures {
      ...recipeStructureFragment
    }
  }
  ${RECIPE_STRUCTURE_FRAGMENT}
`;

// Queries
export const AI_COPILOT_HEALTH_CHECK = gql`
  query AiCopilotHealthCheck {
    aiCopilotHealth {
      status
      message
    }
  }
`;

// New recipe file queries
export const RECIPE_FILES = gql`
  query RecipeFiles {
    recipeFiles {
      name
      title
      size
      lastModified
    }
  }
`;

export const RECIPE_CONTENT = gql`
  query RecipeContent($name: String!) {
    recipeContent(name: $name)
  }
`;

// Mutations
export const START_AI_COPILOT_CONVERSATION = gql`
  mutation StartAiCopilotConversation($recipeName: String) {
    startAiCopilotConversation(recipeName: $recipeName) {
      conversationContext {
        ...conversationContextFragment
      }
    }
  }
  ${CONVERSATION_CONTEXT_FRAGMENT}
`;

export const CHAT_WITH_AI_COPILOT = gql`
  mutation ChatWithAiCopilot(
    $message: String!
    $conversationId: String
    $recipeName: String
  ) {
    chatWithAiCopilot(
      message: $message
      conversationId: $conversationId
      recipeName: $recipeName
    ) {
      chatResponse {
        response
        recipeModified
        recipeContent
        conversationId
      }
    }
  }
`;
